import React, { useContext } from 'react';
import AppContext from '../../../../context/AppContext';

// Database mein "self_powered" / "implement" save hai — yahan usay
// saaf/parhne layak lafzon mein badal rahe hain.
function formatEquipmentType(type) {
  if (type === 'implement') return 'Implement';
  return 'Self-Powered';
}

const CategoryCard= ({ category, onClick }) => {
  const {baseUrlForFile} = useContext(AppContext);
  return (
    <div 
      className="category-card-item"
      onClick={() => onClick(category.name)}
    >
      <div className="category-image-box">
        <img 
          src={`${baseUrlForFile}/${category.image}`} 
          alt={category.name}
          className="category-img"
        />
        {/* Hover par dikhega — equipment type ka badge */}
        <span className="category-type-badge">
          {formatEquipmentType(category.equipment_type)}
        </span>
      </div>
      <div className="category-name-box">
        {category.name}
      </div>
    </div>
  );
};

export default CategoryCard;